import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

/* Actions & Selectors */
import TherapiesAndProcedures from '../../../../Components/TherapiesAndProcedures/TherapiesAndProcedures';
import {
	getProceduresByDepartmentAction,
	updateDepartmentProceduresAction,
} from '../../DepartmentsActions';
import { getInitialValuesForDepartmentProcedures } from '../../DepartmentsSelectors';
import { getTherapiesAction } from '../../../../../Vendors/VendorsActions';

class DepartmentTherapies extends PureComponent {
	componentDidMount() {
		this.props.getProceduresByDepartment(this.props.departmentId);
		this.props.getTherapies();
	}

	onUpdateDepartmentProcedures = data => this.props.updateDepartmentProcedures(this.props.departmentId, this.formatProcedures(data.procedures));

	formatProcedures = (procedures) => {
		return {
			'ids': procedures ? Object.keys(procedures).filter((key) => {
				if (procedures[key]) {
					return key;
				}
			}) : [],
		};
	};

	render() {
		return (
			<TherapiesAndProcedures
				therapies={this.props.therapies}
				onSubmit={this.onUpdateDepartmentProcedures}
				initialValues={this.props.initialValues}
				therapyName="therapies"
				procedureName="procedures"
			/>
		);
	}
}

DepartmentTherapies.propTypes = {};

const mapStateToProps = state => ({
	initialValues: getInitialValuesForDepartmentProcedures(state),
	therapies: state.vendorsReducer.therapies,
	departmentTherapies: state.departmentReducer.departmentTherapies,
});

const mapDispatchToProps = dispatch => ({
	getProceduresByDepartment: departmentId => dispatch(getProceduresByDepartmentAction(departmentId)),
	getTherapies: () => dispatch(getTherapiesAction()),
	updateDepartmentProcedures: (departmentId, procedures) => dispatch(updateDepartmentProceduresAction(departmentId, procedures)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DepartmentTherapies));
